<template>
    <div class="studio-home">
        <section class="hero">
            <div class="hero-copy">
                <h1>开启你的创作<span>花艺/园艺/婚庆创作吧</span></h1>
                <p>传统插花、现代花艺、园林景观、花艺环境、婚庆礼仪虚拟仿真一站式实训平台</p>
            </div>
            <div class="hero-art" aria-label="优秀花艺作品轮播">
                <img v-for="(slide, index) in slides" :key="slide.src" :src="slide.src" :class="{ active: index === slideIndex }" :alt="slide.author" :aria-hidden="index !== slideIndex" />
                <div class="hero-credit"><span>{{ slides[slideIndex].author }}</span></div>
                <div class="hero-dots">
                    <button v-for="(slide, index) in slides" :key="index" type="button" :class="{ active: index === slideIndex }" :aria-label="`查看第 ${index + 1} 张花艺作品`" @click="slideIndex = index"></button>
                </div>
            </div>
        </section>

        <section class="creation-section">
            <div class="section-heading">
                <h2>开始创作</h2>
            </div>
            <div class="creation-grid">
                <a
                    v-for="item in editors"
                    :key="item.sceneType"
                    class="creation-card editor-card"
                    :style="{ '--card-color': item.color, '--card-soft': item.soft }"
                    :href="editorHref(item.sceneType)"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <div class="creation-row">
                        <span class="creation-icon"><i :class="item.icon"></i></span>
                        <div class="creation-copy"><h3>{{ item.title }}</h3><p>{{ item.description }}</p></div>
                    </div>
                    <span class="creation-arrow">→</span>
                </a>
                <router-link class="creation-card ai-card" to="/ai3d" style="--card-color:#b36b16;--card-soft:#fff3df">
                    <div class="creation-row"><span class="creation-icon"><i class="el-icon-box"></i></span><div><h3>AI 3D 生成</h3><p>图片或文字快速生成可用三维素材</p></div></div>
                    <span class="creation-arrow">→</span>
                </router-link>
                <router-link class="creation-card ai-card" to="/ai-chat" style="--card-color:#d45f79;--card-soft:#ffedf2">
                    <div class="creation-row"><span class="creation-icon"><i class="el-icon-chat-dot-round"></i></span><div><h3>AI 对话</h3><p>随时获得园林、园艺与花艺创作建议</p></div></div>
                    <span class="creation-arrow">→</span>
                </router-link>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    data() {
        return {
            slideIndex: 0,
            slideTimer: null,
            slides: [
                '陈玉霞老师作品',
                '徐铭璐同学作品',
                '黄云玲教授作品',
                '陈玉霞老师作品',
                '徐铭璐同学作品',
                '黄云玲教授作品',
                '黄云玲教授作品',
            ].map((author, index) => ({
                src: require(`@/assets/hero-carousel/flower-0${index + 1}.png`),
                author,
            })),
            editors: [
                { sceneType: 'TRADITIONAL_FLOWER', title: '数字插花 · 3D', description: '沿用现有真花虚拟仿真与插花练习', icon: 'iconfont icon-a-xianxing_anquanbaozhangfuben27', color: '#21965b', soft: '#eaf8f0' },
                { sceneType: 'LANDSCAPE', title: '现代花艺 / 园林景观 · 3D', description: '在三维空间中搭建花艺与景观作品', icon: 'el-icon-box', color: '#3687e9', soft: '#eaf3ff' },
                { sceneType: 'FLORAL_ENVIRONMENT', title: '花艺环境 · 2D', description: '平面布置、场景搭配与方案快速表达', icon: 'el-icon-picture-outline', color: '#6e61e8', soft: '#f0eeff' },
            ],
        };
    },
    mounted() {
        this.slideTimer = window.setInterval(() => { this.slideIndex = (this.slideIndex + 1) % this.slides.length; }, 3500);
    },
    beforeDestroy() {
        window.clearInterval(this.slideTimer);
    },
    methods: {
        editorHref(sceneType) {
            const address = sceneType === 'TRADITIONAL_FLOWER' ? this.$editAddr : this.$gardenEditAddr;
            const authToken = localStorage.getItem('authToken') || localStorage.getItem('access_token') || '';
            const query = new URLSearchParams();
            if (authToken) query.set('authToken', authToken);
            if (sceneType === 'FLORAL_ENVIRONMENT') query.set('type', '2d');
            return query.toString() ? `${address}?${query.toString()}` : address;
        },
    },
};
</script>

<style lang="scss" scoped>
.studio-home { color: #18201c; }
.hero {
    min-height: 300px;
    display: grid;
    grid-template-columns: minmax(0, 1.25fr) minmax(330px, .75fr);
    overflow: hidden;
    border-radius: 24px;
    background: linear-gradient(122deg, #e5f7ec 0%, #f2fbf5 47%, #ecf4ff 100%);
    box-shadow: 0 10px 32px rgba(33, 79, 53, .08);
}
.hero-copy { align-self: center; padding: 40px; }
.hero h1 { max-width: 720px; margin: 0 0 16px; font-size: clamp(28px, 2.7vw, 42px); line-height: 1.3; letter-spacing: -.03em; }
.hero h1 span { color: #21965b; }
.hero p { max-width: 690px; margin: 0; color: #647169; font-size: 15px; line-height: 1.9; }
.hero-art { position: relative; min-height: 300px; }
.hero-art img { position: absolute; inset: 18px 20px 76px; width: calc(100% - 40px); height: calc(100% - 94px); object-fit: contain; opacity: 0; transform: translateX(14px) scale(.96); filter: drop-shadow(0 18px 22px rgba(44, 76, 55, .16)); transition: opacity .55s ease, transform .55s ease; }
.hero-art img.active { opacity: 1; transform: none; }
.hero-credit { position: absolute; right: 20px; bottom: 36px; left: 20px; display: flex; justify-content: center; pointer-events: none; }
.hero-credit span { max-width: 100%; padding: 5px 12px; border: 1px solid rgba(33,150,91,.12); border-radius: 999px; color: #4d6657; background: rgba(255,255,255,.86); font-size: 13px; line-height: 1.5; text-align: center; }
.hero-dots { position: absolute; bottom: 16px; left: 50%; display: flex; gap: 6px; transform: translateX(-50%); }
.hero-dots button { width: 7px; height: 7px; padding: 0; border: 0; border-radius: 999px; background: #cad9ce; cursor: pointer; }
.hero-dots button.active { width: 20px; background: #21965b; }
.creation-section { margin-top: 34px; }
.section-heading { margin-bottom: 18px; }
.section-heading h2 { margin: 0; font-size: 24px; }
.creation-grid { display: grid; grid-template-columns: repeat(6, minmax(0, 1fr)); align-items: stretch; gap: 20px; }
.creation-card { position: relative; grid-column: span 2; box-sizing: border-box; min-width: 0; min-height: 180px; display: flex; align-items: flex-start; padding: 24px 24px 58px; overflow: hidden; border: 1px solid #e8eee9; border-radius: 20px; background: #fff; color: #18201c; text-decoration: none; box-shadow: 0 6px 18px rgba(33,79,53,.045); }
.editor-card { text-align: left; cursor: pointer; transition: transform .2s ease, box-shadow .2s ease, border-color .2s ease; }
.editor-card:hover { transform: translateY(-3px); border-color: var(--card-color); box-shadow: 0 18px 42px rgba(33,79,53,.13); }
.editor-card:focus-visible { outline: 3px solid var(--card-color); outline-offset: 3px; }
.creation-card.ai-card { grid-column: span 3; transition: transform .2s ease, box-shadow .2s ease; }
.creation-card.ai-card:hover { transform: translateY(-3px); box-shadow: 0 18px 42px rgba(33,79,53,.13); }
.creation-row { width: 100%; min-width: 0; display: flex; align-items: flex-start; gap: 16px; }
.creation-row > div { flex: 1; min-width: 0; }
.creation-icon { width: 56px; height: 56px; flex: 0 0 auto; display: grid; place-items: center; border-radius: 16px; color: var(--card-color); background: var(--card-soft); }
.creation-icon i { font-size: 28px; }
.creation-row h3 { margin: 0 0 8px; font-size: 18px; font-weight: 650; line-height: 1.45; overflow-wrap: anywhere; }
.creation-row p { margin: 0; color: #89948d; font-size: 14px; line-height: 1.6; }
.creation-arrow { position: absolute; right: 20px; bottom: 16px; width: 36px; height: 36px; display: grid; place-items: center; border-radius: 50%; color: var(--card-color); background: var(--card-soft); font-size: 22px; }
@media (max-width: 1200px) { .creation-card { grid-column: span 3; } .creation-card.ai-card { grid-column: span 3; } }
@media (max-width: 760px) { .hero { grid-template-columns: 1fr; } .hero-copy { padding: 28px; } .hero-art { min-height: 240px; } .creation-card, .creation-card.ai-card { grid-column: span 6; } }
</style>
